<template>
  <div class="container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <h1>批量下单文件</h1>
      </div>
      <el-row>
        <el-col :span="8">
          <div style="display: flex;align-items: flex-start;">
            <el-upload action="no" :limit="1" :file-list="uploadForm.fileList" class="upload-demo" ref="upload"
              :auto-upload="false" :http-request="uploadOk">
              <el-button size="small" icon="el-icon-upload2" type="primary">上传下单书目文件</el-button>
              <div slot="tip" class="el-upload__tip">
                <el-tag size="small" type="success" effect="plain">只能上传Excel文件，文件内容必须包含ISBN和数量，可先下载样例文件再进行操作！</el-tag>
              </div>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <div style="display: flex;align-items: flex-start;">
              <el-input size="small" style="width:210px" v-model="copyNum">
                <template slot="prepend">最小库存 >=</template>
              </el-input>
              <el-button style="margin-left: 20px;" size="small" icon="el-icon-share" type="success"
                @click="matchProduct">匹配下单商品</el-button>
            </div>
            <div slot="tip" class="el-input__tip">
              <el-tag size="small" type="danger" effect="plain">若[最小库存]大于0，则只查询系统中库存大于此值的数据</el-tag>
            </div>
          </div>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button size="small" icon="el-icon-download" plain type="success" @click="downloadModel">下载样例文件</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix" id="TableType-success">
        <h1>匹配成功商品清单 
          <!-- <span style="color:red; font-size: 14px; font-weight: normal;">↙全选按钮只能控制折扣匹配【低于、等于】的数据，【高于】的数据只能靠手动勾选/取消勾选（不受全选按钮的影响）</span> -->
          <template v-if="$store.state.userInfo.userNumber < 0">
            <p class="total_je">
              原始金额：<span style="color: #888; font-weight: normal;">{{ chushiJE }}</span>
              真实金额：<span style="color: #000">{{ zhenshiJE }}</span>
              低折扣节省：<span style="color: green">{{ jieshengJE }}</span>
              高折扣损耗：<span style="color: red">{{ sunhaoJE }}</span>
            </p>
            <p style="float: right;;">
              <el-radio-group v-model="sortType" size="mini" @input="sortChange">
                <el-radio-button label="0">不排序</el-radio-button>
                <el-radio-button label="1">符合折扣</el-radio-button>
                <el-radio-button label="2">低折扣</el-radio-button>
                <el-radio-button label="3">可替换</el-radio-button>
                <el-radio-button label="4">已替换</el-radio-button>
              </el-radio-group>
            </p>
          </template>
        </h1>
      </div>
      <el-row>
        <el-col :span="24">
          <div v-for="(data, i) in tableDatas" :key="i" :id="'TableType-'+ i">
            <div v-if="i == 1" style="margin-top: 10px">
              <el-divider></el-divider>
              <h2 style="font-size: 15px; margin-left: 20px;">匹配折扣高于原查询折扣的商品清单</h2>
            </div>
            <div v-if="i == 2" style="margin-top: 10px">
              <el-divider></el-divider>
              <h2 style="font-size: 15px; margin-left: 20px;">匹配库存低于原查询库存的商品清单</h2>
            </div>
            <el-table v-loading="loading" element-loading-text="正在匹配商品中，请稍后。。。" ref="multipleTable" :data="data"
              tooltip-effect="dark" style="width: 100%" @selection-change="(val) => handleSelectionChange(val, i)">
              <el-table-column type="selection" align="center" width="55" />
              <el-table-column property="warehouseUserName" label="供应商" width="120">
                <span slot-scope="scope">
                  {{ scope.row.warehouseUserName }}
                </span>
              </el-table-column>
              <el-table-column align="center" label="ISBN" width="150" prop="productSn">
              </el-table-column>
              <el-table-column label="原书名" align="center" prop="searchProductName" sortable
                sort-by="productnameMatchlevel">
                <template slot-scope="scope">
                  <div :title="scope.row.productnameMatchlevel + '%'"
                    v-html="highlighted(scope.row.searchProductName, scope.row.productName)"></div>
                </template>
              </el-table-column>
              <el-table-column label="书名" align="center" prop="productName">
              </el-table-column>
              <!-- <el-table-column label="匹配度" align="center" prop="productnameMatchlevel" width="100" sortable>
                <template slot-scope="scope">
                  <div :title="scope.row.searchProductName">{{ scope.row.productnameMatchlevel }}</div>
                </template>
              </el-table-column> -->
              <el-table-column v-if="$store.state.userInfo.userNumber < 0" label="原折扣" align="center" prop="discountMatchlevel" width="100">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.searchDiscount }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="折扣" prop="discountHavelow" :align="i == 0 ? 'left' : 'center'" :width="i == 0 ? 140 : 80">
                <template slot-scope="scope">
                  <div :style="{
                    color: scope.row.discount > scope.row.searchDiscount ? 'red' : scope.row.discount < scope.row.searchDiscount ? 'green' : 'unset',
                    fontWeight: scope.row.discount != scope.row.searchDiscount ? 'bold' : 'unset'
                  }">{{ scope.row.discount }}
                    <el-button v-if="scope.row.backupStock" type="text" @click="handleReplaceBackupStock(scope.row)"
                     :title="scope.row.backupFlag == 2 ? '恢复为' : '替换为'"
                     :style="{ color: scope.row.backupFlag == 2 ? '#f56c6c' : '#409EFF' }"
                    >
                      <i class="el-icon-caret-right"></i> {{ scope.row.backupStock.discount}}
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-if="i == 1" label="折扣差" align="center" prop="discountDval" width="90" sortable>
              </el-table-column>
              <el-table-column label="折扣价" prop="backupFlag" width="80" align="center">
                <template slot-scope="scope">
                  <div>￥{{ scope.row.shopPrice }}</div>
                </template>
              </el-table-column>
              <el-table-column label="定价" prop="marketPrice" width="80" align="center">
                <template slot-scope="scope">
                  <div>￥{{ scope.row.marketPrice }}</div>
                </template>
              </el-table-column>
              <el-table-column v-if="i != 2" prop="buyNum" align="center" width="80" label="购买数量"></el-table-column>
              <el-table-column v-if="i == 2" prop="searchBuyNum" align="center" width="80" label="原购数量"></el-table-column>
              <el-table-column prop="productNum" label="库存数量" width="80" align="center"></el-table-column>
              <el-table-column v-if="i != 2" align="center" width="80" label="剩余">
                <template slot-scope="scope">
                  <span v-if="scope.row.productNum >= scope.row.buyNum">{{
                    scope.row.productNum - scope.row.buyNum
                    }}</span>
                  <span v-else>0</span>
                </template>
              </el-table-column>
              <el-table-column v-if="i == 2" prop="stockDval" label="数量差" align="center" width="90" sortable>
              </el-table-column>
            </el-table>
            <div v-if="i==tableDatas.length-1" style="margin-top: 10px; text-align: right;">
              <el-button type="primary" icon="el-icon-shopping-cart-2" style="width: 130px;"
                @click="addCart">加入购物车</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card">
      <div id="TableType-error" slot="header" class="clearfix">
        <h1>匹配失败商品清单</h1>
      </div>
      <el-row>
        <el-col :span="24">
          <div>
            <el-table ref="multipleTable1" :data="tableData1" tooltip-effect="dark" style="width: 100%">
              <el-table-column prop="productSn" label="ISBN" width="260"></el-table-column>
              <el-table-column prop="searchBuyNum" label="购买数量"></el-table-column>
              <el-table-column prop="productNum" align="center" label="库存数量">
                <template slot-scope="scope">
                  <div>{{ scope.row.id != null ? scope.row.productNum : '' }}</div>
                </template>
              </el-table-column>
              <el-table-column label="折扣" align="center" prop="discount" />
              <el-table-column label="定价" prop="marketPrice" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.marketPrice != null ? '￥' + scope.row.marketPrice : ''}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <div class="anchor-nav" title="点击进行快捷跳转">
      <a @click.prevent="scrollTo('TableType-success')" class="anchor-btn" style="background-color: #67C23A;"><i>1</i>匹配成功</a>
      <a @click.prevent="scrollTo('TableType-1')" class="anchor-btn"><i>2</i>高折扣</a>
      <a @click.prevent="scrollTo('TableType-2')" class="anchor-btn"><i>3</i>低库存</a>
      <a @click.prevent="scrollTo('TableType-error')" class="anchor-btn" style="background-color: #f73131;"><i>4</i>匹配失败</a>
    </div>
  </div>
</template>
<script>
// import Vue from "vue";
import { downFile, getAction, postAction } from "../../api/index";
import { mapGetters } from "vuex";
export default {
  name: "batchOrder",
  data() {
    return {
      tableData: [],
      tableDatas: [[]],
      tableData1: [],
      loading: false,
      selectProductList: [],
      selectProductLists: [[],[]],
      // 记录 高折扣 行的手动选中状态
      manualSelected: new Set(),
      fileList: [],
      fileName: "",
      uploadForm: {
        copyNum: 0,
        fileList: [],
      },
      url: {
        downloadModel: "/common/downloadTemplate",
        // uploadCSVFile: this.baseurl+"/bookshop/front/common/upload",
        uploadCSVFile: "/common/upload",
        matchProduct: "/common/matchProduct",
        addCart: "/cart/addcart",
        queryCartList: "/cart/queryCartList",
      },
      copyNum: 0,
      isSelectAll: false,
      sortType: 0 // 排序方式
    };
  },
  components: {},
  computed: {
    ...mapGetters(["isNaName"]),
    chushiJE() { 
      return this.selectProductList.reduce((acc, cur) => {
        let data = cur.backupFlag === 2 ? cur.backupStock : cur;
        // const price = cur.backupFlag != 2 && cur.discount > cur.searchDiscount ? cur.marketPrice * cur.searchDiscount : data.shopPrice;
        const price = cur.backupFlag === 2 ?  data.shopPrice : ( cur.discount == cur.searchDiscount ? data.shopPrice : cur.marketPrice * cur.searchDiscount )
        return acc + Math.round((( price ) * data.buyNum) * 100);
      }, 0) / 100;
    },
    zhenshiJE() { 
      return this.selectProductList.reduce((acc, cur) => {
        return acc + Math.round((cur.shopPrice * cur.buyNum) * 100);
      }, 0) / 100;
    },
    jieshengJE() { 
      return this.selectProductList.filter(item => item.discount < item.searchDiscount).reduce((acc, cur) => {
        let je = 0;
        if (cur.backupFlag === 2) {
          // 手动替换低折扣
          je = cur.shopPrice * cur.buyNum - cur.backupStock.shopPrice * cur.backupStock.buyNum
        } else { 
          // 只有低折扣
          je = ( cur.shopPrice - cur.marketPrice * cur.searchDiscount) * cur.buyNum;
        }
        return acc + Math.round(( je ) * 100);
      }, 0) / 100;
    },
    sunhaoJE() { 
      return this.selectProductList.filter(item => item.discount > item.searchDiscount).reduce((acc, cur) => {
        return acc + Math.round((cur.shopPrice - cur.marketPrice * cur.searchDiscount ) * cur.buyNum * 100);
      }, 0) / 100;
    },
  },
  mounted() {},
  methods: {
    submitUpload() {
      this.$refs.upload.submit();
    },
    uploadOk(val) {
      // console.log("uploadOk===", val);
      this.loading = true;
      this.sortType = 0;
      let fd = new FormData();
      fd.append("copyNum", this.copyNum);
      fd.append("userId", this.$store.state.userInfo.id);
      fd.append("userNumber", this.$store.state.userInfo.userNumber);
      fd.append("file", val.file);
      // postAction(this.url.uploadCSVFile, fd).then((res) => {
      postAction(this.url.matchProduct, fd).then((res) => {
        if (res.data.success) {
          // this.tableData = res.data.result.success;
          if (this.$store.state.userInfo.userNumber < 0) {
            this.tableDatas = [[], []];
            res.data.result.success.forEach(item => {
              item.backupFlag = 0;
              // (item.discountMatchlevel === 1 ? this.tableDatas[1] : this.tableDatas[0]).push(item);
              if (item.discountMatchlevel === 1) { 
                // 计算折扣差
                item.discountDval = (item.discount - item.searchDiscount).toFixed(2);
                this.tableDatas[1].push(item);
              }else { 
                this.tableDatas[0].push(item);
              }
            });
            // scope.row.searchBuyNum - scope.row.productNum
            if (res.data.result.success0 && res.data.result.success0.length) { 
              this.tableDatas.push(
                res.data.result.success0.map(item => ({
                  ...item,
                  stockDval: item.searchBuyNum - item.productNum
                }))
              );
            }
            this.tableData1 = res.data.result.error;
          } else { 
            this.tableDatas = [res.data.result.success];
            this.tableData1 = [...res.data.result.success0, ...res.data.result.error];
          }
        } else {
          this.$message.warning("暂未匹配到您所要找的图书！");
        }
        this.loading = false;
        this.$refs.upload.clearFiles();
      });
    },
    handleSuccess(res) {
      this.loading = false;
      // console.log("res :>> ", res);
      if (res.success) {
        this.loading = false;
        this.tableData = res.result.success;
        this.tableData1 = res.result.error;
      } else {
        this.$message.warning("暂未匹配到您所要找的图书！");
        this.loading = false;
      }
    },
    matchProduct() {
      this.$refs.upload.submit();
      // getAction(this.url.matchProduct, {
      //   fileN: this.fileName,
      //   copyNum: this.copyNum,
      // }).then((res) => {
      //   if (res.data.success) {
      //     this.loading = false;
      //     this.tableData = res.data.result.success;
      //     this.tableData1 = res.data.result.error;
      //   } else {
      //     this.$message.warning("暂未匹配到您所要找的图书！");
      //     this.loading = false;
      //   }
      // });
    },
    downloadModel() {
      downFile(this.url.downloadModel, { flag: "1" }).then((res) => {
        let url = window.URL.createObjectURL(new Blob([res.data]));
        let a = document.createElement("a");
        a.setAttribute("download", "批量下单模板.xlsx");
        a.href = url;
        a.click();
      });
    },
    handleSelectionChange(val, i) {
      this.selectProductLists[i] = val;
      this.selectProductList = [].concat(...this.selectProductLists);
    },
    handleSelectAll(val) { 
      this.$nextTick(() => { 
        this.isSelectAll = !this.isSelectAll;
        if (this.isSelectAll) {
          val.forEach(row => {
            if (row.discountMatchlevel == 1) {
              const shouldBeSelected = this.manualSelected.has(row);
              this.$refs.multipleTable.toggleRowSelection(row, shouldBeSelected);
            }
          });
        } else {
          this.$refs.multipleTable.clearSelection();
          this.manualSelected.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          });
        }
      });
    },
    // 手动勾选/取消单行时，维护 manualSelected
    handleSelect(selection, row) {
      if (row.discountMatchlevel == 1) {
        if (selection.includes(row)) {
          this.manualSelected.add(row);
        } else {
          this.manualSelected.delete(row);
        }
      }
    },
    //加入购物车
    addCart() {
      const that = this;
      if(that.selectProductList.length == 0){
        that.$message({
            message: "未选择图书！",
            type: "warning",
          });
        return;
      }
      let storeCartList = that.$store.state.shopCart
      let params = [];
      for (let i = 0; i < that.selectProductList.length; i++) {
        var sp = that.selectProductList[i]
        // 校验库存是否已超过真实库存。
        if (storeCartList && storeCartList.length > 0) {
          for (let j = 0; j < storeCartList.length; j++) {
            let cartObj = storeCartList[j]
            if(cartObj 
              && cartObj.productStockId === sp.id
              && (cartObj.productNumber + sp.buyNum) > sp.productNum
            ){
              that.$message.error(sp.productName + " 加购的图书数量(包括购物车中的)大于当前库存");
              return false
            }
          }
        }
        let proParams = {};
        proParams.id = that.selectProductList[i].id;
        proParams.productNum = that.selectProductList[i].buyNum;
        // 传递查询折扣到购物车中
        proParams.custDiscount = that.selectProductList[i].searchDiscount;
        proParams.custLabel = that.selectProductList[i].searchLabel;
        params.push(proParams);
      }
      let user_id = that.$store.state.userInfo.id;
      postAction(that.url.addCart, {
        params: JSON.stringify(params),
        userId: user_id,
      }).then((res) => {
        if (res.data.success) {
          that.getCartItems();
          that.$message({message: "加入购物车成功！", type: "success",});
        }
      });
    },
    getCartItems() {
      //获取购物车信息,并存入vuex
      getAction(this.url.queryCartList, {
        uid: this.$store.state.userInfo.id,
      }).then((ret) => {
        if (ret.data.success) {
          this.$store.state.shopCart = ret.data.result;
          window.sessionStorage.setItem("shopCart", JSON.stringify(ret.data.result));
        }
      });
    },
    // 替换为备份（低折扣）的库存
    handleReplaceBackupStock(row) { 
      if(!row.backupStock) return;
      const index = this.tableDatas[0].findIndex(item => item.id === row.id);
      if (index === -1) return;
      const currRowSelected = this.selectProductList.findIndex(item => item.id === row.id) !== -1;
      if (!row.backupFlag) {
        // 最开始标记原数据为1，备用数据为2
        row.backupFlag = 1;
        row.backupStock.backupFlag = 2;
        row.backupStock.searchDiscount = row.searchDiscount;
        row.backupStock.searchProductName = row.searchProductName;
        row.backupStock.discountHavelow = row.discountHavelow;
        row.backupStock.discountMatchlevel = -1;
      }
      const backup = row.backupStock;
      Object.keys(row).forEach(key => {
        if (key === 'backupStock') return;
        const temp = row[key];
        row[key] = backup[key];
        backup[key] = temp;
        // 用 Vue.set 确保新属性也是响应式的
        // Vue.set(row, key, backup[key]);
        // Vue.set(backup, key, temp);
        // this.$set(row, key, backup[key]);
        // this.$set(backup, key, temp);
      });
      // 用 splice 替换整行，强制触发响应式更新
      // const newRow = { ...row, backupStock: { ...row.backupStock } };
      this.tableDatas[0].splice(index, 1, { ...row });
      this.$refs.multipleTable[0].toggleRowSelection(this.tableDatas[0][index], currRowSelected);
    },
    sortChange(val) { 
      let sortName,sortOrder;
      switch (val) {
        case "1":
          sortName = "discountMatchlevel";
          sortOrder = "descending";
          break;
        case "2":
          sortName = "discountMatchlevel";
          sortOrder = "ascending";
          break;
        case "3":
          sortName = "discountHavelow";
          sortOrder = "descending";
          break;
        case "4":
          sortName = "backupFlag";
          sortOrder = "descending";
          break;
      }
      if (sortName) {
        this.$refs.multipleTable[0].sort(sortName, sortOrder);
      } else { 
        this.$refs.multipleTable[0].clearSort();
      }
    },
    // 高亮
    highlighted(str, target) {
      if (!str) return '';
      if (!target) return str;
      return str.split('').map(char => {
        if (target.includes(char)) {
          return `<span style="color: #f73131; ">${char}</span>`;
        }
        return char;
      }).join('');
    },
    scrollTo(id) {
      const el = document.getElementById(id);
      console.log(el);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      // this.currentAnchor = id;
    },
  },
};
</script>
<style lang="scss" scoped>
.clearfix {
  h1 {
    font-size: 18px;
    color: #333;
  }
}
.el-progress {
  width: 50%;
  line-height: 3;
  margin-left: 15px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple-light {
  line-height: 36px;
}
.el-input__tip{
  margin-top: 7px;
}
.total_je{
  display: inline-block;
  margin-left: 30px;
  font-size: 15px;
  font-weight: normal;
}
.total_je span{
  margin-right: 10px;
  font-size: 16px;
  font-weight: bold;
}

/* 左侧全局居中 */
.anchor-nav {
  position: fixed;
  right: calc(750px + 50%);
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 999;
  align-items: flex-end;
}
.anchor-btn {
  padding: 5px;
  background: #409eff;
  color: #fff;
  border-radius: 2px;
  text-decoration: none;
  font-size: 12px;
  white-space: nowrap;
  text-align: left;
  transition: background 0.3s, opacity 0.3s, width  0.3s;
  cursor: pointer;
  opacity: 0.5;
  overflow: hidden;
  width: 18px;
}

.anchor-btn:hover {
  background: #66b1ff;
  opacity: 1;
  width: 80px;
}
.anchor-btn i{
  display: inline-block;
  width: 18px;
  margin-right: 6px;
  text-align: center;
}
</style>
